import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { TransactionActivityEventHydration } from './transaction-activity-event-hydration.dto';

/**
 * A transaction activity event with hydrated related records.
 */
export class TransactionActivityEventDto extends ActivityEventDto {
  hydrated?: TransactionActivityEventHydration;
}
